import { render, staticRenderFns } from "./buy2.vue?vue&type=template&id=153eae7b&scoped=true"
import script from "./buy2.vue?vue&type=script&lang=js"
export * from "./buy2.vue?vue&type=script&lang=js"
import style0 from "./buy2.vue?vue&type=style&index=0&id=153eae7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153eae7b",
  null
  
)

export default component.exports